<template>
  <v-container>
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        新規登録
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="username"
            label="ユーザ名(ニックネーム)"
            :counter="name_max"
            :rules="nameRules"
            required
          ></v-text-field>
          <v-text-field
            v-model="email"
            label="メールアドレス"
            :rules="emailRules"
            required
          >
          </v-text-field>
          <v-text-field
            v-model="password"
            label="パスワード"
            :type="show ? 'text' : 'password'"
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="passRules"
            @click:append="show = !show"
            required
          >
          </v-text-field>
          <v-select
            v-model="gym"
            item-text="name"
            item-value="id"
            :items="gyms"
            menu-props="auto"
            label="ホームジム"
            hide-details
            single-line
          ></v-select>
        </v-form>
        <v-btn class="info mt-3" @click="signUp">登録</v-btn>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
/* eslint-disable no-console */
import { toSlackSend } from "../../plugins/slack";

import { db } from "../../plugins/firebase";
import firebase from "../../plugins/firebase";
import store from "../../stores";
import User from "../../Models/UserModel";
import CommonMethods from "../../mixins/CommonMethods";

export default {
  name: "signup",
  mixins: [CommonMethods],
  data() {
    return {
      username: "",
      email: "",
      password: "",
      gym: "",
      gyms: [],
      name_max: 20,
      pass_min: 6,
      show: false,
      valid: false,
      lazy: false,
      nameRules: [
        (v) => !!v || "ユーザ名は必須です",
        (v) =>
          (!!v && this.name_max >= v.length) ||
          `${this.name_max}文字以内で入力してください`,
      ],
      emailRules: [
        (v) => !!v || "メールアドレスは必須です",
        (v) => /.+@.+\..+/.test(v) || "メールアドレスの形式が不正です",
      ],
      passRules: [
        (v) => !!v || "パスワードは必須です",
        (v) =>
          (!!v && this.pass_min <= v.length) ||
          `${this.pass_min}文字以上で入力してください`,
      ],
      sharedState: store.state,
    };
  },
  mounted() {
    this.checkState();
  },
  methods: {
    /**
     * フォームのバリデーションチェック
     */
    validate() {
      return this.$refs.form.validate();
    },
    /**
     * ユーザ登録する
     */
    async signUp() {
      if (!this.validate()) return;
      // 認証ユーザを作成
      const result = await firebase
        .auth()
        .createUserWithEmailAndPassword(this.email, this.password);
      // 表示名を設定
      result.user.updateProfile({ displayName: this.username });
      var userModel = new User();
      userModel.uid = result.user.uid;
      userModel.email = this.email;
      userModel.displayName = this.username;
      userModel.homeGymId = this.gym;
      var obj = userModel.getObject();
      // ユーザを作成
      this.createSync("M_USER", obj);
      alert("アカウントを作成しました！");
      await this.send(this.username);
      store.setLoginState(true);
      this.checkState();
      this.$router.push("/");
    },
    /**
     * 課題の投稿をSlackに通知する
     */
    async send(username) {
      var text = "★ユーザ登録★\n";
      text += `${username} さんがJAMに参加しました！🤣`;
      // Slackに投稿する
      toSlackSend(text);
    },
    /**
     * ユーザの認証状態をセットする
     */
    checkState() {
      firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          store.setLoginState(true);
        } else {
          store.setLoginState(false);
        }
      });
    },
  },
  firestore() {
    return {
      gyms: db.collection("M_GYM"),
    };
  },
};
</script>
